import { useSelector } from 'react-redux';
import { userHasTagSelectorAccess } from '@/utils/tagSelectorAccess';
import type { WARootState } from '@/store/store';

/**
 * True when the API says the authenticated user can use the global household tag selector.
 */
export function useShowTagSelectorDropdown(): boolean {
  return useSelector((state: WARootState) =>
    userHasTagSelectorAccess(state.appView.UserInfo),
  );
}
